import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { useDispatch } from 'react-redux';
import { handlePutRequest } from '../../../service/PutTemplate';
import { handleGetRequest } from '../../../service/GetTemplate';
import { endPoints } from '../../../Config';

const EditViewDisbursement = ({ editable, viewable, onHide, rowRecord, onClose }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {
            rast: ''
        },
        validationSchema: Yup.object({}),
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('adminUser') || '{}');

            const editData = {
                id: data.id,
                roleName: data.roleName
            };

            const response = await dispatch(handlePutRequest(editData, endPoints.updateRole, true));
            if (response?.status === 200) {
                formik.resetForm();
                onHide();
            }
            setLoadingBtn(false);
        }
    });

    const getMerchantsById = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getMerchantList(rowRecord.id), true);
        if (response) {
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('roleName', response?.data?.roleName);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        if (editable || viewable) {
            getMerchantsById();
        }
    }, [rowRecord]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="transactionType">
                            Transaction Type <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="transactionType" name="transactionType" placeholder="Enter Transaction Type" value={formik?.values?.transactionType} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.transactionType && formik.errors.transactionType && <small className="p-error">{formik.errors.transactionType}</small>}
                    </div>
                </div>
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                {!viewable && (
                    <Button label={editable ? 'Update' : 'Save'} icon={editable ? 'pi pi-pencil' : 'pi pi-save'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                )}
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onClose()} />
            </div>
        </form>
    );
};

export default EditViewDisbursement;
